import clsx from "clsx";
import { memo, SyntheticEvent } from "react";
import defaultToken from "../../assets/tokens/default.png";
import { getAssetDeliveryUrl } from "../../assetDelivery";

const TOKEN_ALIASES: Record<string, string> = {
  axleth: "eth",
  btcb: "btc",
  ftm: "wftm",
  furylegacy: "fury.legacy",
  graviton: "grav",
  local: "whlocal",
  matic: "wmatic",
  paxg: "gpaxg",
  raclegacy: "rac.legacy",
  shdlegacy: "shd.legacy",
  tao: "wtao",
  weth: "eth",
  wbnb: "bnb",
  wglmr: "glmr",
  whsol: "sol",
  yfuzn: "fuzn",
};

const TOKEN_PATH_ALIASES: Record<string, string> = {
  xusk: "ghost-tokens/usk.png",
};

const tokenImageName = (denom: string) => {
  const normalized = denom.trim().toLowerCase();
  const symbol = normalized.endsWith(".legacy")
    ? normalized
    : normalized.split(".").at(0) || "default";
  return TOKEN_ALIASES[symbol] || symbol || "default";
};

/** Local, bundled fallback used when a CDN image cannot be loaded. */
export const getDenomIconFallbackSrc = () => defaultToken;

/**
 * Resolve a token image at call/render time, so newly uploaded custom IDs do
 * not require a rujira.ui rebuild.
 */
export const getDenomIconSrc = (denom: string) => {
  const imageName = tokenImageName(denom);
  return getAssetDeliveryUrl(
    TOKEN_PATH_ALIASES[imageName] || `tokens/${imageName}.png`
  );
};

/** Apply the bundled default.png after a remote token request fails. */
export const handleDenomIconError = (
  event: SyntheticEvent<HTMLImageElement, Event>
) => {
  const image = event.currentTarget;
  const fallback = getDenomIconFallbackSrc();
  if (image.src === fallback) return;
  image.onerror = null;
  image.src = fallback;
};

export const IconDenom = memo(
  ({ denom, className }: { denom: string; className?: string }) => (
    <img
      src={getDenomIconSrc(denom)}
      onError={handleDenomIconError}
      alt={`${denom} token`}
      className={clsx("icon-denom", className)}
    />
  )
);

IconDenom.displayName = "IconDenom";
